<template>
   <div>
       <loading :show="loading"></loading>
    <div class="text-right py-2">
        <a href="#" class="btn btn-primary btn-lg text-white" @click="showNewActivityModal()">Add new activity</a>
    </div>
    <table class="table table-borderless">
        <tbody>
        <tr>
            <th style="width:20%">Thumbnail</th>
            <th style="width:30%">Title</th>
            <th style="width:15%">Status</th>
            <th style="width:35%">Actions</th>
        </tr>

        <template v-if="activities.current_page == 1 && activities.data.length == 0">
            <tr>
                <td colspan="5" style="height:300px">
                    <span class="h4">No activities yet. <a href="#" class="btn btn-light" @click="showNewActivityModal()">Add new activity</a></span>
                </td>
            </tr>
        </template>
        <template v-else>
            <tr v-for="activity in activities.data" :key="activity.id">
                <td class="activity-image">
                    <img :src="activity.thumb" />
                </td>
                <td>{{ activity.title }}</td>
                <td><span class="activity-status" :class="{unpublished: activity.status == 0, published: activity.status == 1}">
                {{ activity.status_text }}
            </span></td>
                <td class="activity-actions">
                    <a class="btn btn-outline-secondary" href="#" @click="editActivity(activity)">Edit</a>
                    <a class="btn btn-outline-danger" @click="deleteActivity(activity)" href="#">Delete</a>
                    <a class="btn btn-outline-success" @click="togglePublish(activity)" href="#">
                    <span v-if="activity.status == 0">
                        Publish
                    </span>
                        <span v-else>
                        Unpublish
                    </span>
                    </a>
                </td>
            </tr>
        </template>
        </tbody>
    </table>
       <pagination :data="activities" @pagination-change-page="getActivities">
           <span slot="prev-nav">&lt; Previous</span>
           <span slot="next-nav">Next &gt;</span>
       </pagination>
       <modal name="newActivityModal" @before-close="beforeClose('newActivityModal')" classes="whatswhat-modal new-activity-modal" width="60%" height="auto" :shiftY="0.3">
           <div class="new-activity-modal-wrapper">
               <div class="close-modal" @click="closeModal('newActivityModal')"><i class="icon-cross"></i></div>
               <h2>Add new activity</h2>
               <hr>
               <div id="add-activity-wrapper" class="d-flex">
                   <div class="detailedstep">

                           <p class="detailedstep__title mt-3 mb-1" :class="{'text-danger': newActivity.errors.title}">
                               Activity title*
                           </p>
                           <div class="detailedstep__input">
                               <input :class="{ 'input__text--error': $v.newActivity.title.$error }"
                                      type="text"
                                      name="title"
                                      v-model="newActivity.title"
                                      placeholder="Activity title"
                                      class="input__text">
                               <span class="detailedstep__error text-left ml-0" v-if="$v.newActivity.title.$error && !$v.newActivity.title.required">Activity title is required</span>
                               <span class="detailedstep__valid" v-else>Field ok</span>
                           </div>


                       <p class="detailedstep__title mt-3 mb-1">
                           Activity description*

                       </p>
                       <div class="detailedstep__input">
                           <textarea :class="{ 'input__text--error': $v.newActivity.description.$error }"
                                     name="activity_description"
                                     v-model="newActivity.description"
                                     id="activity-description"
                                     cols="6"
                                     rows="6"
                                     placeholder="Activity description"
                                     class="input__text">
                           </textarea>
                           <span class="detailedstep__error text-left ml-0" v-if="$v.newActivity.description.$error && !$v.newActivity.description.required">Activity description is required</span>
                           <span class="detailedstep__valid" v-else>Field ok</span>
                       </div>

                       <p class="detailedstep__title mt-3 mb-1">Activity image</p>
                       <vue-dropzone
                           ref="myVueDropzone"
                           id="dropzone"
                           :options="dropzoneOptions"
                           @vdropzone-success-multiple="dropzoneCompleted"
                           @vdropzone-mounted="addImages"
                           v-on:vdropzone-removed-file="removeThisFile"
                       ></vue-dropzone>
                   </div>
              </div>
           </div>
           <div class="modal-footer text-right">
               <hr class="my-4">
               <a href="#" @click="submitActivity()" class="btn btn-primary btn-lg text-white">
                   {{ newActivity.type == 'create' ? 'Save' : 'Update' }} Activity
               </a>
               <a @click="closeModal('newActivityModal')" class="btn btn-danger btn-lg text-white">
                   Cancel
               </a>
           </div>
       </modal>

     </div>


</template>

<script>
import Loading from '../Loading.vue';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {decimal, required} from "vuelidate/lib/validators";
export default {
    props: ['business'],
    components: {
        'loading': Loading,
        vueDropzone: vue2Dropzone,
    },

    data() {
        return {
            loading: false,
            dropzoneOptions: {
                url: '/post',
                autoProcessQueue: false,
                thumbnailHeight: 200,
                thumbnailWidth: 200,
                uploadMultiple: true,
                maxFilesize: 3,
                maxFiles: 1,
                parallelUploads: 1,
                addRemoveLinks:true,
                headers: {
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                },
            },
            activities: {},
            newActivity: {
              title: '',
              description: '',
              type: 'create',
              images: [],
              errors: {
                title: false,
                description: false
              }
            },
        }
    },
    validations: {
        newActivity: {
            title: {
                required,
            },
            description: {
                required,
            }
        },
    },
    methods: {
        closeModal(modal, reloadData = false) {
            if(reloadData) this.getActivities();
            this.$modal.hide(modal);
            this.$v.$reset();
        },
        getActivities(page = 1) {
            axios.get('fetch-activities?page=' + page)
                .then(response => {
                    this.activities = response.data;
                });
        },
        showDd(file) {
            console.log(file);
        },
        showModal(id) {
            this.$modal.show(id);
        },
        showNewActivityModal() {
            this.showModal('newActivityModal');
        },
        removeThisFile () {
            if(this.newActivity.type === 'update') {
                let self = this;
                axios.delete('activities/' + this.newActivity.id + '/images/')
                     .then(response => {
                        if(response.data.success) {
                            self.getActivities(self.activities.current_page);
                            self.$toastr.s("Your image has been deleted successfully", "Image deleted");
                        }
                     });
            }
        },
        dropzoneCompleted(response) {
            this.refreshTablePage();
            this.closeModal('newActivityModal');
        },
        beforeClose(modal) {
            if(modal == 'newActivityModal') {
                this.newActivity = {
                    title: '',
                    description: '',
                    price: '',
                    type: 'create',
                    images: [],
                    errors: {
                        title: false,
                        description: false
                    }
                }
            }
        },
        addImages() {
            let self = this;
            console.log(self.newActivity);
            if(self.newActivity.type === 'update') {
                if(self.newActivity.image) {
                        var file = JSON.parse(self.newActivity.img_info);
                        var url = self.newActivity.image;
                        self.$refs.myVueDropzone.manuallyAddFile(file, url);
                }

            }
        },
        submitActivity() {
            this.$v.$touch();
            if(this.$v.$invalid){
                return;
            }else {
                let self = this;
                self.loading = true;
                if (self.newActivity.type === 'update') {
                    let _activity = {
                        title: self.newActivity.title,
                        description: self.newActivity.description,
                    }
                    axios.put('activities/' + self.newActivity.id, _activity)
                        .then(response => {
                            self.loading = false;
                            if (response.data.success) {
                                if(self.$refs.myVueDropzone.getQueuedFiles().length) {
                                    self.$refs.myVueDropzone.setOption('url', 'activities/' + self.newActivity.id + '/images');
                                    self.$refs.myVueDropzone.processQueue();
                                } else {
                                    this.refreshTablePage();
                                    this.closeModal('newActivityModal');
                                }

                            }
                        });
                } else {
                    axios.post('activities', this.newActivity)
                        .then(response => {
                            self.loading = false;
                            if (response.data.success) {
                                if(self.$refs.myVueDropzone.getQueuedFiles().length) {
                                    self.$refs.myVueDropzone.setOption('url', 'activities/' + response.data.id + '/images');
                                    self.$refs.myVueDropzone.processQueue();
                                } else {
                                    this.refreshTablePage();
                                    this.closeModal('newActivityModal');
                                }
                            }
                        });
                }
            }
        },
        refreshTablePage() {
          this.getActivities(this.activities.current_page);
        },
        editActivity(activity) {
            this.newActivity = {
                id: activity.id,
                title: activity.title,
                description: activity.description,
                image: activity.image,
                img_info: activity.img_info,
                type: 'update'
            }
            this.showNewActivityModal();


        },
        togglePublish(activity) {
            let self = this;
            self.loading = true;
            let _activity = {
                status: activity.status == 0 ? 1 : 0,
                title: activity.title,
                description: activity.description,
            }
            axios.put('activities/'+activity.id, _activity)
                .then(response => {
                   self.loading = false;
                   if(response.data.success) {
                       activity.status = response.data.data.status;
                       activity.status_text = response.data.data.status_text;
                   }

                });
        },
        deleteActivity(activity) {
            let self = this;
            self.loading = true;
            axios.delete('activities/' + activity.id)
                .then(response => {
                   self.loading = false;
                   if(response.data.success) {
                       self.$toastr.s("Activity has been deleted successfully", "Activity deleted");
                       self.getActivities();
                   }
                });
        }
    },
    mounted() {
        this.app_url = APP_URL;
        this.getActivities();
    }
}
</script>
